import { PaymentMethodTypes } from 'features/payments/PaymentProviderIdTypes';

export class OrgSettings {
  private readonly _settings;
  constructor(settings: Record<string, any>) {
    this._settings = settings;
  }

  getPreferredOnrampMethod(): PaymentMethodTypes {
    return (
      this._settings?.payments?.preferredOnrampMethod ||
      PaymentMethodTypes.Bridge
    );
  }

  getPreferredOfframpMethod():
    | PaymentMethodTypes.Bridge
    | PaymentMethodTypes.EasyPay {
    return (
      this._settings?.payments?.preferredOfframpMethod ||
      PaymentMethodTypes.Bridge
    );
  }
}

export const createOrgSettingsFactory = (
  data: Record<string, any>
): OrgSettings => {
  return new OrgSettings(data);
};
